import { useContext } from 'react';
import { AuthContext, AuthContextType } from './Auth';

export const useAuthProvider = (): AuthContextType => useContext(AuthContext);
